import { fillPlot, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { highestAt, lowestAt } from "../math/windowExtremes";

/**
 * Donchian Channel (research §1.4), as TV Donchian Channels: the highest
 * high and the lowest low of the period and their middle.
 */
export default {
  id: "donchian-channel",
  name: "Donchian Channel",
  isOscillator: false,
  inputs: [
    periodInput("period", "Period", 20, { min: 5, max: 200 }),
  ],
  plots: [
    linePlot("middle", "Middle", PALETTE.LIME),
    linePlot("top", "Top", PALETTE.AQUA),
    linePlot("bottom", "Bottom", PALETTE.YELLOW),
    fillPlot("background", "Background", PALETTE.LIME, ["top", "bottom"]),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    const readHigh = priceReader(bars, PRICE_SOURCE.HIGH);
    const readLow = priceReader(bars, PRICE_SOURCE.LOW);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const top = highestAt(readHigh, index, period);
      const bottom = lowestAt(readLow, index, period);

      series.top[index] = top;
      series.bottom[index] = bottom;
      series.middle[index] = (top + bottom) / 2;
    }
  },
};
